/**
 * Section Height Store for Lobby2.0
 * Remembers each section's measured height so lazy placeholders reserve the right space.
 *
 * This used to persist scroll positions to localStorage as well. The lobby's vertical
 * position is now restored from a section anchor (shared/utils/scrollAnchor) and the
 * per-section horizontal positions were never captured in multi view, so nothing read
 * them back.
 */

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface SectionHeightState {
  heights: Record<string, number>;

  setSectionHeight: (sectionName: string, height: number) => void;
  getSectionHeight: (sectionName: string) => number | undefined;
}

export const useScrollStore = create<SectionHeightState>()(
  devtools(
    (set, get) => ({
      heights: {},

      setSectionHeight: (sectionName, height) =>
        set(
          (state) => ({ heights: { ...state.heights, [sectionName]: height } }),
          false,
          'setSectionHeight'
        ),

      getSectionHeight: (sectionName) => get().heights[sectionName],
    }),
    { name: 'ScrollStore' }
  )
);
